import Vue from 'vue'
import Vuex from 'vuex'
import storePlugins from "../plugins/store-plugins";
import persisted from "../plugins/persisted";

import modules from './modules';

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins: [storePlugins, persisted.plugin],
  strict: false
})